
// src/store/slices/companySeoSlice.js
import { createSlice } from "@reduxjs/toolkit";
import {
  fetchCompanySeoThunk,
  updateCompanySeoThunk,
} from "../thunks/companySeoThunks";

const initialState = {
  seoData: null,
  loading: false,
  error: null,
};

const companySeoSlice = createSlice({
  name: "companySeo",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCompanySeoThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCompanySeoThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.seoData = action.payload;
      })
      .addCase(fetchCompanySeoThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateCompanySeoThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateCompanySeoThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.seoData = action.payload;
      })
      .addCase(updateCompanySeoThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default companySeoSlice.reducer;